import ApiService from '../services/apiService';

export default ({ dispatch, params, callback, successCallback }) =>
  ApiService.request('get', '/public/previreds', { dispatch, params, callback, successCallback });
